module.exports = __webpack_public_path__ + "static/img/11areaB_02.bd4a82b.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/11areaB_02.png
// module id = 1091
// module chunks = 1